import { Link } from "react-router-dom";
import Dashboard from "../../Components/Dashboard";
import { useEffect, useState } from "react";
import Loader from "../../loader";

const DashboardPage = () => {

  return (
    <>
        <Dashboard />
    </>
  );
};
export default DashboardPage;
